export const addProfileAction = (data) => {
    return (dispatch, getState, { getFirebase }) => {
      const firestore = getFirebase().firestore();
      //console.log(application);
      firestore
        .collection(data.collection)
        .doc(data.id)
        .update({
            imageUrl: data.url
        })
        .then(() => {
          dispatch({
            type: "ADD_PROFILE",
            success: true
          });
        })
        .catch((err) => {
          dispatch({
            type: "ADD_PROFILE_ERR",
            err
          });
        });
    };
  };
  